import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";
export const fetchShowActivity = createAsyncThunk(
    'activity/showActivity',
    async (id, { rejectWithValue }) => {
        try {

            const response = await api.get(`/activities/${id}`)
            return response.data.data;
        } catch (error) {
            console.error("API Error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


const showActivitySlice = createSlice({
    name: "showActivity",
    initialState: {
        loading: false,
        error: null,
        activity: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowActivity.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.activity = null; // Reset activity on new fetch
            })
            .addCase(fetchShowActivity.fulfilled, (state, action) => {
                state.loading = false;
                console.log("Redux Updated with:", action.payload);
                state.activity = action.payload || {}; // Prevent null state
            })
            .addCase(fetchShowActivity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});


export default showActivitySlice.reducer;